$(() => {

  /**
   * prevent a function from being called too often, taken from Underscore via David Walsh
   * https://davidwalsh.name/javascript-debounce-function
   *
   * @param      {Function}    func       The function to debounce
   * @param      {number}      wait       How often to let it be called, in ms
   * @param      {boolean}     immediate  Whether to call it upfront or after the wait
   * @return     {Function}
   */
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  const $headerElement = $('.nav-wrapper');
  const $window = $(window);
  const updateHeaderSticky = function() {
    if ($window.scrollTop() > 5) {
      $headerElement.addClass('sticky');
    } else {
      $headerElement.removeClass('sticky');
    }
  }

  $(document).on('scroll', debounce(updateHeaderSticky, 10, false));

  updateHeaderSticky();


  /**
   * What follows is all pretty messy because I was copying
   * from the slider plugin's documentation in a rush. The
   * original it's modified from is here under "Single
   * Element - Dot Navigation":
   * https://meandmax.github.io/lory/
   */

  const sliderEl = document.querySelector('.js_slider');

  if (sliderEl) {

    const sliderNav = document.querySelector('.slider_nav');

    if (sliderNav) {
      function handleSliderNavEvent(e) {
        switch (e.type) {
          case 'after.lory.init':
            for (var el of sliderNav.children) {
              el.addEventListener('click', (e) => {
                const targetIndex = Array.prototype.indexOf.call(sliderNav.children, e.currentTarget);
                slider.slideTo(targetIndex);
              })
            }
            sliderNav.children[0].classList.add('active');
            break;
          case 'after.lory.slide':
            for (var el of sliderNav.children) {
              el.classList.remove('active');
            }
            sliderNav.children[e.detail.currentSlide - 1].classList.add('active');
            break;
          case 'on.lory.resize':
            for (var el of sliderNav.children) {
              el.classList.remove('active');
            }
            sliderNav.children[0].classList.add('active');
            break;

        }
      }
      sliderEl.addEventListener('after.lory.init', handleSliderNavEvent);
      sliderEl.addEventListener('after.lory.slide', handleSliderNavEvent);
      sliderEl.addEventListener('on.lory.resize', handleSliderNavEvent);
    }

    const slider = lory(sliderEl, {
      infinite: 1,
      enableMouseEvents: true
    });
  }

  window.Plaintext.DescriptionExpander.init();
  window.Eqa.ShareLinks.init();
  window.Eqa.MediaBlock.init();
});